import { render } from "./ComponentSidebarV2.vue?vue&type=template&id=21fa3f64&scoped=true"
import script from "./ComponentSidebarV2.vue?vue&type=script&lang=js"
export * from "./ComponentSidebarV2.vue?vue&type=script&lang=js"

import "./ComponentSidebarV2.vue?vue&type=style&index=0&id=21fa3f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fa3f64"]])

export default __exports__